module.exports = __webpack_public_path__ + "static/media/ELS150NG04.26de6fa6.png";